import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Home } from './pages/Home';
type Theme = 'light' | 'dark';
type DisplayFont = 'anton' | 'bebas' | 'oswald' | 'bigshoulders' | 'barlow' | 'leaguegothic';
interface AppProps {
  theme?: Theme;
  font?: DisplayFont;
}
export function App({
  theme = 'light',
  font = 'anton'
}: AppProps) {
  return <div className={`${theme === 'dark' ? 'dark' : ''} font-set-${font}`} data-id="element-0" data-mp="2rlyqmg88cok1">
      <BrowserRouter data-id="element-1" data-mp="2mmcds7wbdabr">
        <Routes data-id="element-2" data-mp="2mmvkesgikcah">
          <Route path="/" element={<Landing data-id="element-4" data-mp="2mjzm330r7lli" />} data-id="element-3" data-mp="2mndqshww46w4" />
          <Route path="/full" element={<Home data-id="element-6" data-mp="31bs09botatln" />} data-id="element-5" data-mp="31agpgrwy8ll1" />
          <Route path="*" element={<Landing data-id="element-8" data-mp="31cjog1g2xp1w" />} data-id="element-7" data-mp="31c9y2cr4hfvo" />
        </Routes>
      </BrowserRouter>
    </div>;
}